import { createThunk } from 'utils/createThunk';
import * as backendAPI from 'api/backendAPI/announcements';
import types from 'constants/actionTypes';

export const fetchAnnouncements = createThunk({
  apiCall: backendAPI.fetchAnnouncements,
  type: types.GET_ANNOUNCEMENTS_REQUEST,
});

export const closeAnnouncements = () => ({
  type: types.CLOSE_ANNOUNCEMENTS
});
